<template>
  <div>
    <el-upload
      class="tech-image-upload"
      action="/oss/ossUploadReturnUrlAndFileId"
      :show-file-list="false"
      :auto-upload="false"
      accept=".jpeg,.jpg,.png,.gif"
      :on-change="onImageChange"
      :drag="drag"
      :disabled="disabled || flag"
    >
      <div
        class="el-upload el-upload--picture-card d-flex justify-content-center align-items-center"
        :style="`width:${width};height:${height};`"
      >
        <div slot="trigger">
          <i
            v-if="!imageSrc"
            class="el-icon-plus"
            :style="`font-size:${iconSize};font-weight:${iconWeight};`"
          ></i>
        </div>

        <div
          v-if="imageSrc"
          class="tech-image position-relative"
          style="width: 100%; height: 100%"
        >
          <el-image
            style="width: 100%; height: 100%"
            :fit="fit"
            :src="imageSrc"
          ></el-image>
          <div
            class="shadow position-absolute d-flex align-items-center justify-content-center"
          >
            <div>
              <span @click="onImagePreview()" class="mr-2">
                <i class="el-icon-zoom-in"></i
              ></span>
              <span @click="onImageRefresh()" class="mr-2" v-if="!disabled">
                <i class="el-icon-refresh"></i
              ></span>
              <span @click="onImageRemove()" v-if="!disabled">
                <i class="el-icon-delete"></i
              ></span>
            </div>
          </div>
        </div>
      </div>
    </el-upload>

    <div v-show="false" class="imagesViewer" v-viewer="{ movable: true }">
      <img :src="imageSrc" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: { type: Object, default: () => {} },
    disabled: { type: Boolean, default: false },
    drag: { type: Boolean, default: false },
    headerText: { type: String, default: '' },
    width: { type: String, default: '350px' },
    height: { type: String, default: '360px' },
    iconSize: { type: String, default: '40px' },
    iconWeight: { type: String, default: 'inherit' },
    fit: { type: String, default: 'contain' },
  },
  data() {
    return { flag: false }
  },
  computed: {
    imageSrc() {
      const file = this.value || {}
      if (file.raw) return URL.createObjectURL(file.raw)
      if (file.originImageUrl) return file.originImageUrl
      if (this.disabled) return '/image/static/img/nopic.jpg'
      return ''
    },
  },
  watch: {
    imageSrc: {
      handler(val) {
        if (val) {
          setTimeout(() => {
            this.flag = true
          }, 0)
          return
        }
        setTimeout(() => {
          this.flag = false
        }, 0)
      },
      immediate: true,
    },
  },
  methods: {
    onImageChange(file) {
      this.changeValue(file)
      this.flag = true
    },
    onImagePreview() {
      if (this.imageSrc) {
        this.viewer = this.$el.querySelector('.imagesViewer').$viewer
        this.viewer.show()
      }
    },
    onImageRemove() {
      this.changeValue()
    },
    onImageRefresh() {
      this.flag = false
    },
    changeValue(value = {}) {
      this.$emit('input', value)
      this.$emit('update:value', value)
    },
  },
}
</script>
<style lang="scss" scoped>
.tech-image:hover {
  .shadow {
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1;
  }
}
.shadow {
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  border-radius: 6px;
  opacity: 0;
  transition: opacity 0.3s;
  color: #fff;
  line-height: 20px;
  padding: 2px;
}

// 重写element 样式
::v-deep {
  .el-upload-dragger {
    width: 100%;
    height: 100%;
    border: none;
  }
  .el-upload--picture-card i {
    font-size: 25px;
  }
}
</style>
